import React, { forwardRef } from "react";
import { makeStyles, Container } from "@material-ui/core";
import BoardListGroup from "../../../components/MainComponent/BoardComponent/BoardListGroup";
import MetaSeo from "../../../components/MetaSeo";

const useStyles = makeStyles((theme) => ({
  BoardTop: {
    paddingTop: "8rem",
    paddingBottom: "4rem",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "4rem",
      paddingBottom: "2rem",
    },
  },
}));

interface BoardContainerProps {
  //   children: React.ReactNode | null | string | undefined;
  match: any;
  history: any;
}

function BoardContainer({ match, history }: BoardContainerProps) {
  const classes = useStyles();

  return (
    <Container className={classes.BoardTop}>
      <MetaSeo
        data={{
          title: "노동인권문화제 공지사항",
          description: "노동인권문화제와 관련된 공지입니다",
          canonical: "http://laborbusan.or.kr/notice/",
        }}
      />
      <BoardListGroup match={match} history={history} />
    </Container>
  );
}

export default BoardContainer;
